import { Box, List, styled } from "@mui/material";
import React from "react";

export type MenuBaseProps = {
    children: React.ReactNode,
    width?: number | string,
    boxShadow?: number | string,
    borderRight?: number | string,
    footer?: React.ReactNode
}

const AdminNav = styled(List)({
    '& .MuiListItemButton-root': {
        paddingLeft: 24,
        paddingRight: 24,
    },
    '& .MuiListItemIcon-root': {
        minWidth: 0,
        marginRight: 16,
    },
    '& .MuiSvgIcon-root': {
        fontSize: 20,
    },
});
export function MenuBase({ children, width = 200, boxShadow = 5, borderRight = "1.2px solid", footer }: MenuBaseProps) {
    return (
        <Box sx={{
            display: "flex",
            width: width,
            minWidth: width,
            boxShadow: boxShadow,
            borderRight: borderRight,
            borderColor: '#99989877',
            flexDirection: "column",
            justifyContent: "space-between"
        }}
        >
            <AdminNav>
                {children}
            </AdminNav>
            {footer}
        </Box>
    );
}

export default MenuBase;